var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#16_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.772 3.593a1.919 1.919 0 0 0-3.274-1.356L3.37 8.364a3.253 3.253 0 0 0 4.6 4.6l6.126-6.128a.75.75 0 0 1 1.06 1.06l-6.126 6.128a4.753 4.753 0 0 1-6.72-6.72l6.126-6.128a3.418 3.418 0 0 1 4.951 4.711l-.117.123-6.134 6.127a2.085 2.085 0 0 1-3.557-1.473c0-.553.22-1.083.61-1.474l5.661-5.653a.75.75 0 1 1 1.06 1.06L5.25 10.25a.586.586 0 0 0 .413.998.59.59 0 0 0 .413-.17L12.21 4.95l.127-.141c.28-.341.435-.77.435-1.216"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "16_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.334 0h16v16h-16z"
  })))));
};
export default Svg16;